import { useState } from "react";
import { ChevronsUpDown, Home, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useGoogleUser } from "./GoogleAuth";

// Navbar: one-tap switch between the vaults linked to the signed-in Google owner.
export const VaultSwitcher = () => {
  const { data } = useGoogleUser();
  const [open, setOpen] = useState(false);
  const households = data?.households || [];
  if (households.length < 2) return null;
  const current = households.find((h) => h.current);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="vault-switcher-btn" title="Switch vault" className="hidden sm:inline-flex items-center gap-1.5 h-9 rounded-full border border-border bg-card px-3 text-xs hover:border-primary transition-colors max-w-[180px]">
          <Home className="h-3.5 w-3.5 text-primary shrink-0" /><span className="truncate">{current?.name || "Your vaults"}</span><ChevronsUpDown className="h-3 w-3 text-muted-foreground shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-1.5" data-testid="vault-switcher-menu">
        <div className="px-2 py-1 text-[10px] uppercase tracking-widest font-mono text-muted-foreground">Your vaults</div>
        {households.map((h) => (
          <a key={h.slug || "primary"} href={h.current ? undefined : h.path} onClick={() => setOpen(false)} data-testid={`vault-switch-${h.slug || "primary"}`} className={`flex items-center gap-2 rounded-lg px-2 py-2 text-sm ${h.current ? "bg-muted cursor-default" : "hover:bg-muted"}`}>
            <span className="flex-1 truncate">{h.name}</span>{h.current && <Check className="h-3.5 w-3.5 text-primary" />}
          </a>
        ))}
        <div className="px-2 pt-1.5 pb-1 text-[11px] text-muted-foreground border-t border-border mt-1">Each vault asks for its own PIN.</div>
      </PopoverContent>
    </Popover>
  );
};
